import React from 'react';

const ImagenContainerManualCiclos = () => {
  return (
    <div className="py-2 my-4">
      <img
        src="assets/imagenes/web_ mc_ciclos hito_esquema_manual_escritorio.png"
        class="img1 img-fluid"
      ></img>
      <img
        src="assets/imagenes/web_ mc_ciclos hito_esquema_manual_movil.png"
        class="img2 img-fluid"
      ></img>
    </div>
  );
};

export default ImagenContainerManualCiclos;
